import * as React from "react"
import { useEditorState } from "@tiptap/react"
import { Button } from "../../tiptap-ui-primitive/button"
import { UndoIcon } from "../../tiptap-icons/undo-icon"
import { RedoIcon } from "../../tiptap-icons/redo-icon"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"

export interface UndoRedoButtonProps {
  action: "undo" | "redo"
}

export const UndoRedoButton: React.FC<UndoRedoButtonProps> = ({ action }) => {
  const editor = useTiptapEditor()

  const state = useEditorState({
    editor,
    selector: (ctx) => ({
      canUndo: ctx.editor?.can().undo() ?? false,
      canRedo: ctx.editor?.can().redo() ?? false,
    }),
  })

  const handleClick = () => {
    if (!editor) return
    if (action === "undo") {
      editor.chain().focus().undo().run()
    } else {
      editor.chain().focus().redo().run()
    }
  }

  const isDisabled = action === "undo" ? !state.canUndo : !state.canRedo
  const Icon = action === "undo" ? UndoIcon : RedoIcon
  const label = action === "undo" ? "Отменить" : "Повторить"

  return (
    <Button
      onClick={handleClick}
      data-disabled={isDisabled}
      disabled={isDisabled}
      aria-label={label}
      title={label}
    >
      <Icon className="tiptap-button-icon" />
    </Button>
  )
}
